import { render, staticRenderFns } from "./LedgerAccountWiseDownloadReport.vue?vue&type=template&id=afab5610&scoped=true&"
import script from "./LedgerAccountWiseDownloadReport.vue?vue&type=script&lang=js&"
export * from "./LedgerAccountWiseDownloadReport.vue?vue&type=script&lang=js&"
import style0 from "./LedgerAccountWiseDownloadReport.vue?vue&type=style&index=0&id=afab5610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afab5610",
  null
  
)

export default component.exports